import { ReactNode } from "react";

type PageTitleProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

/**
 * 各ページの上部に置く小さなタイトル領域 (オプション)
 */
export const PageTitle = ({ title, subtitle, actions }: PageTitleProps) => {
  return (
    <div className="page-title">
      <div>
        <div className="page-title-text">{title}</div>
        {subtitle && <div className="page-title-sub">{subtitle}</div>}
      </div>
      {actions && <div className="card-actions">{actions}</div>}
    </div>
  );
};
